import axios from "axios";
import { NEW_API_URL } from "../constants/Globals";

export const fetchClientSubscriptionStatus = async (clientId) => {
  try {
    if (clientId) {
      let url = `${NEW_API_URL}/master/subscription-types/subscription-details/${clientId}`;
      const res = await axios.get(url);
      if (res.data.status) {
        return res.data.data.isActive;
      } else {
        alert("There is a problem in fetching subscription detail.");
      }
    } else {
      return true;
    }
  } catch (err) {
    alert(
      "There is a problem in fetching subscription detail. Please try again!!!!!"
    );
    console.error(err);
  }
};

export const fetchAiRequestLimitExceedStatus = async (groupId) => {
  const requestExceedUrl = `${NEW_API_URL}/master/groups/${groupId}/subscription-period-ai-usage`;
  let isQuotaExceeded = false;
  await axios
    .get(requestExceedUrl)
    .then((response) => {
      isQuotaExceeded = response.data.data.isQuotaExceeded;
    })
    .catch((error) => {
      console.error("Error checking request exceed status:", error);
    });
  return isQuotaExceeded;
};

export const fetchAiRequestLimitDetail = async (groupId) => {
  const requestExceedUrl = `${NEW_API_URL}/master/groups/${groupId}/subscription-period-ai-usage`;
  let reqData = null;
  await axios
    .get(requestExceedUrl)
    .then((response) => {
      reqData = response.data.data;
    })
    .catch((error) => {
      console.error("Error checking request exceed data:", error);
    });
  return reqData;
};

export const fetchAiResponseLimitExceedStatus = async (groupId) => {
  const responseExceedUrl = `${NEW_API_URL}/master/groups/${groupId}/subscription-period-response-count`;
  let isQuotaExceeded = false;
  await axios
    .get(responseExceedUrl)
    .then((response) => {
      isQuotaExceeded = response.data.data.isQuotaExceeded;
    })
    .catch((error) => {
      console.error("Error checking response exceed status:", error);
    });
  return isQuotaExceeded;
};

export const fetchAiResponseLimitDetail = async (groupId) => {
  const responseExceedUrl = `${NEW_API_URL}/master/groups/${groupId}/subscription-period-response-count`;
  let respData = null;
  await axios
    .get(responseExceedUrl)
    .then((response) => {
      respData = response.data.data;
    })
    .catch((error) => {
      console.error("Error checking response exceed data:", error);
    });
  return respData;
};

export const buySubscriptionPlan = async (data) => {
  return axios.post(`${NEW_API_URL}/payment/create-checkout-session`, data);
};
export const changeSubscriptionPlan = async (groupId, data) => {
  return axios.post(
    `${NEW_API_URL}/master/subscription-types/upgrade/${groupId}`,
    data
  );
};
export const manageSubscriptionPlan = async (groupId) => {
  return axios.get(
    `${NEW_API_URL}/master/subscription-types/manage/${groupId}`
  );
};
